export default {
  'landing.nav_logo': 'Qpressen',
  'landing.nav_cta': '시작하기',
  'landing.hero_title': 'QR 코드 하나로\n프레젠테이션을 제어하세요',
  'landing.hero_subtitle': '스마트폰으로 QR 코드를 스캔하면 바로 원격 제어가 시작됩니다. 별도 앱 설치 없이, 브라우저만으로.',
  'landing.hero_cta': '무료로 시작하기',
  'landing.features_title': '강력한 기능',
  'landing.features_subtitle': '프레젠테이션에 필요한 모든 것을 제공합니다',
  'landing.feature_qr_title': 'QR 원격 제어',
  'landing.feature_qr_desc': 'QR 코드를 스캔하면 스마트폰이 리모컨으로 변합니다. 앱 설치 없이 바로 사용하세요.',
  'landing.feature_pdf_title': 'PDF 프레젠테이션',
  'landing.feature_pdf_desc': 'PDF 파일을 업로드하면 바로 프레젠테이션 모드로 전환됩니다.',
  'landing.feature_sketch_title': '스케치 & 포인터',
  'landing.feature_sketch_desc': '발표 중 실시간으로 화면에 그리고, 포인터로 강조할 수 있습니다.',
  'landing.feature_notes_title': '스피커 노트',
  'landing.feature_notes_desc': '청중에게는 보이지 않는 발표 노트를 스마트폰에서 확인하세요.',
  'landing.feature_share_title': '간편 공유',
  'landing.feature_share_desc': '링크 하나로 프레젠테이션을 공유하고, 실시간으로 함께 볼 수 있습니다.',
  'landing.feature_dashboard_title': '대시보드',
  'landing.feature_dashboard_desc': '모든 프레젠테이션을 한 곳에서 관리하고 정리하세요.',
  'landing.cta_title': '지금 바로 시작하세요',
  'landing.cta_subtitle': '복잡한 설정 없이, QR 코드 하나로 프레젠테이션의 새로운 경험을 만나보세요.',
  'landing.cta_button': '무료로 시작하기',
  'landing.footer_copyright': '© 2025 Qpressen. All rights reserved.',
  'landing.meta_title': 'Qpressen - QR 코드로 프레젠테이션 제어',
  'landing.meta_description': '스마트폰으로 QR 코드를 스캔하면 바로 원격 제어가 시작됩니다. 별도 앱 설치 없이, 브라우저만으로.',
  'landing.og_description': 'QR 코드 하나로 프레젠테이션을 제어하세요',
};
